import { Inline } from "~/components/Inline";
import { ShowAll } from "./ShowAll";

interface DisplayingProps {
  shouts?: number;
  checkins: number;
  venues?: number;
  countries?: number;
  showAll?: boolean;
}

export const Displaying = ({
  shouts,
  checkins,
  venues,
  countries,
  showAll,
}: DisplayingProps) => {
  if (!checkins || checkins === 1) return null;

  return (
    <Inline>
      <span>Displaying</span>
      {shouts && shouts < checkins && <span><strong>{shouts}</strong> of</span>}
      <span><strong>{checkins}</strong> checkins</span>
      {venues && venues > 1 && <span>from <strong>{venues}</strong> cafes</span>}
      {countries && countries > 1 && <span>in <strong>{countries}</strong> countries</span>}
      {showAll && <>&nbsp; <ShowAll /></>}
    </Inline>
  )
}

export default Displaying;
